import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Paths from "@tunnel-enums/index";
import PathSVGElement from "@tunnel-components/@sharded/pathSVG";
import SegmentationGrid from "@tunnel-components/@sharded/camera/segmentation";
import SegmentedTwice from "@tunnel-components/@sharded/widgets/modal/segmented-twice/component";
import * as Lodash from "lodash";
import Scrollbars from "@tunnel-components/@sharded/@widgets/scrollbars";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as i18next from "i18next";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    cameraparams,
    onSegmentatedCamera,
    errorserver,
    progressBarInc,
    onAllReinitialization,
    bntloading,
    getAllZone,
    coords,
    onResetCamera,
    nextCameraActivated,
    onGetMouseOverCoord,
    onResetSection,
    handleToUpdate,
    modalSegmentationTwice,
    zonePolygon,
    camera,
    coordString,
    coordStringMouseOver,
    onRemoveDrawPolygon,
    withdrawPolygon,
    onPolygonCoord,
    virtualDomUpdate,
    onSequenceWarning,
    zone,
    onPolygon,
    onChangeZone,
    loading,
    infos,
    warningsequence,
    reinitialisation,
    onSubmit,
    onSequence,
    numberOfcamera,
    onSequenceReinitialization,
    toggleModalSegmentationTwice,
  } = props;

  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();

  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.CAMERASEGMENTATIONVIEW,
  ]);

  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isUndefined(camera) &&
    !Lodash.isEmpty(camera) &&
    !Lodash.isNull(camera);

  /**
   * @description : retourne un boolean
   * @const
   * @name cameraIsUndefined
   * @type { boolean  }
   */
  const cameraIsUndefined: boolean = Lodash.isUndefined(cameraparams); //

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      error={errorserver}
      key="laurentine-ma-mere"
      onSequenceWarnin={onSequenceWarning}
      onAllReinitialization={onAllReinitialization}
      onSequence={onSequence}
      sequenceInfos={infos}
      sequenceWarning={warningsequence}
      sequenceReinitialization={reinitialisation}
      onSequenceReinitialization={onSequenceReinitialization}
      btnloading={bntloading}
      loading={loading}
    >
      <SegmentedTwice
        isVisible={!siteLoading && modalSegmentationTwice}
        cameraparams={cameraparams}
        onResetCamera={onResetCamera}
        toggleModal={toggleModalSegmentationTwice}
        onResetSection={onResetSection}
      />
      {siteLoading && (
        <section
          className="tunnel-site animated fadeIn"
          id="laurentine-ma-mere"
        >
          {true && (
            <BreadCrumb
              iconSupervision={true}
              links1={
                !cameraIsUndefined
                  ? `${Paths.PathsNamesEnums.CAMERASETTINGID}${camera.id}`
                  : `${Paths.PathsNamesEnums.CAMERAHOME}`
              }
              title={i18next.t("supervision")}
              breadText1={i18next.t("camera")}
              breadText2={`${i18next.t("segmentation")}# ${
                camera && camera.code
              }`}
            />
          )}
          {cameraIsUndefined && (
            <div className="progress-bar animated fadeIn">
              <span
                style={{
                  width: `${Math.ceil(
                    100 * ((progressBarInc + 1) / numberOfcamera)
                  )}%`,
                }}
              >
                <i>{`${Math.ceil(
                  100 * ((progressBarInc + 1) / numberOfcamera)
                )}%`}</i>
              </span>
            </div>
          )}
          <div className="contentAllSiteWithoutOnglet" id="Christian-mon-pere">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="incident-items settings-camera">
                  <div className="incident-player-no" />
                  <div className="one-incident-details with-1-3-columns">
                    <li className="cart-box-incidents animated fadeIn">
                      <div className="cart-incident ">
                        <div className="image-with-snapshot camera-masque-warning ">
                          {!camera.connected && <div className="impossible" />}
                          {!camera.connected && (
                            <div className="noSignalMove">
                              <p style={{ display: "block" }}>
                                {" "}
                                {i18next.t("pas de flux video")}
                              </p>
                            </div>
                          )}

                          {camera && camera.connected && (
                            <PathSVGElement
                              coordString={coordString}
                              coordsDS={coords}
                              handleToUpdate={handleToUpdate}
                              coordStringMouseOver={coordStringMouseOver}
                              coords={onPolygonCoord}
                              coordMouseOver={onGetMouseOverCoord}
                              withdrawPolygon={withdrawPolygon}
                              drawZone={zonePolygon}
                              target={camera.snapshot}
                              camera={camera.id}
                              zone={zone}
                              virtualDomUpdate={virtualDomUpdate}
                            />
                          )}
                        </div>
                      </div>
                    </li>

                    <li className="cart-box-incidents  animated slideInLeft">
                      <div className="cart-incident ">
                        <div className="box-header-custom">
                          <div className="box-center-display">
                            <div className="left part-left">
                              <span>{i18next.t("description")}</span>
                            </div>
                            <div className="left part-left settings-header">
                              <span onClick={onSequence}>
                                <svg
                                  className="search-icons-svg"
                                  width="16"
                                  height="16"
                                  fill="#007ADF"
                                  viewBox="0 0 252 245"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <g>
                                    <path
                                      d="M124.358 0.000441213C54.7838 0.799354 -0.82056 56.457 0.00117927 124.098C0.822918 191.74 58.0707 245.799 127.645 245C197.219 244.202 252.823 188.544 252.001 120.903C251.179 53.2613 193.932 -0.798472 124.358 0.000441213ZM123.81 197.066H123.262C112.579 196.799 104.91 189.077 105.184 178.691C105.458 168.571 113.127 161.381 123.536 161.381H124.084C135.04 161.647 142.436 169.37 142.162 179.756C142.162 189.875 134.492 197.066 123.81 197.066ZM169.006 109.984C166.54 113.446 161.062 117.707 153.94 123.033L146.271 128.093C142.162 131.288 139.423 134.218 138.601 137.147C137.779 139.544 137.506 140.077 137.506 144.87V146.202H107.923V143.805C108.197 133.952 108.471 128.093 112.853 123.299C119.427 115.843 134.219 106.522 134.766 106.256C136.958 104.658 138.601 103.06 139.971 101.196C142.984 96.9352 144.353 93.7396 144.353 90.5439C144.353 86.0168 142.984 82.0222 140.245 78.2939C137.779 74.832 132.849 72.9678 125.727 72.9678C118.606 72.9678 113.949 75.0983 110.936 79.6254C107.923 84.1526 106.553 88.9461 106.553 93.7396V95.0711H76.4229V93.7396C77.2447 75.6309 83.8186 62.8483 96.1447 55.1254C103.814 50.332 113.401 47.9352 124.632 47.9352C139.149 47.9352 151.749 51.3972 161.336 58.3211C171.197 65.245 176.127 75.6309 176.127 89.2124C176.401 96.6689 173.936 103.593 169.006 109.984Z"
                                      fill="#028DFF"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath>
                                      <rect
                                        width="16"
                                        height="16"
                                        fill="white"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                          </div>
                        </div>
                        <div className="descriptionDetailsInfos">
                          {camera.connected && (
                            <div className="initializationInfos">
                              <span
                                className="borderGradian"
                                onClick={onSequenceReinitialization}
                              >
                                <span
                                  className="btnSecondary "
                                  style={{
                                    backgroundColor: "white",
                                    overflow: "visible",
                                  }}
                                >
                                  <span className="textGradianlarge">
                                    {i18next.t("tout reinitialiser")}
                                  </span>
                                </span>
                              </span>
                            </div>
                          )}
                        </div>
                        <div className="contentSequence">
                          <div className="seggrid">
                            {!Lodash.isUndefined(getAllZone) && (
                              <Scrollbars height="100%" width="100%">
                                <SegmentationGrid
                                  myCameraidentifiant={camera.id}
                                  myCameraCode={camera.code}
                                  myCameraIsConnected={camera.connected}
                                  myZoneidentifiant={zone}
                                  items={Utils.transformObjectToArray(
                                    getAllZone
                                  )}
                                  virtualDomUpdate={virtualDomUpdate}
                                  nextCameraActivated={nextCameraActivated}
                                  onChangeZone={onChangeZone}
                                  onRemovePolygonCoord={onRemoveDrawPolygon}
                                  onPolygon={onPolygon}
                                />
                              </Scrollbars>
                            )}
                          </div>

                          <div className="next-button-camera">
                            {cameraIsUndefined && (
                              <div className="button-camera">
                                {authorization && (
                                  <button
                                    className="btnPrimary ripple"
                                    onClick={onSubmit}
                                  >
                                    {" "}
                                    {i18next.t("camera suivante")}
                                  </button>
                                )}
                                {!authorization && (
                                  <div className="btnPrimaryDisabled">
                                    <span>{i18next.t("camera suivante")}</span>
                                  </div>
                                )}
                              </div>
                            )}
                            {!cameraIsUndefined && (
                              <div className="button-camera">
                                {!authorization && (
                                  <div className="btnPrimaryDisabled">
                                    <span>{i18next.t("segmentation")} </span>
                                  </div>
                                )}
                                {authorization && (
                                  <button
                                    className="btnPrimary ripple"
                                    onClick={onSegmentatedCamera}
                                  >
                                    {" "}
                                    {i18next.t("segmentation")}
                                  </button>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </li>
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  cameraparams?: any;
  onSegmentatedCamera?: any;
  getAllZone?: any;
  coords?: any;
  onResetCamera?: any;
  nextCameraActivated?: any;
  onGetMouseOverCoord?: any;
  onResetSection?: any;
  handleToUpdate?: any;
  modalSegmentationTwice?: any;
  zonePolygon?: any;
  camera?: any;
  coordString?: any;
  coordStringMouseOver?: any;
  onRemoveDrawPolygon?: any;
  withdrawPolygon?: any;
  onPolygonCoord?: any;
  virtualDomUpdate?: any;
  onSequenceWarning?: any;
  zone?: any;
  onPolygon?: any;
  onChangeZone?: any;
  loading?: any;
  infos?: any;
  warningsequence?: any;
  reinitialisation?: any;
  onSubmit?: any;
  onSequence?: any;
  numberOfcamera?: any;
  onSequenceReinitialization?: any;
  toggleModalSegmentationTwice?: any;
  errorserver?: any;
  progressBarInc?: any;
  onAllReinitialization?: any;
  bntloading?: any;
}

export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/camera/segmentation/home/component.tsx